"use client"

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { FormattedMessage } from "react-intl";

import NotFoundImage from "@/assets/images/media/404.png";

const NotFound = () => (
  <section className="pt-[150px] pb-[110px] lg:pt-[220px]">
    <div className="container overflow-hidden lg:max-w-[1250px]">
      <div className="mx-auto w-full max-w-[570px]">
        <div className="w-full mb-8 wow fadeInUp" data-wow-delay=".2s">
          <Image
            src={NotFoundImage}
            width={300}
            height={300}
            alt="Not Found Image"
            className="max-w-full mx-auto"
          />
        </div>

        <div className="text-center wow fadeInUp" data-wow-delay=".2s">
          <h2 className="mb-[18px] text-[28px] font-bold text-black dark:text-white sm:text-[35px]">
            <FormattedMessage id="notfound-page-title" />
          </h2>
          <p className="mb-[30px] text-base font-medium text-body sm:text-lg">
            <FormattedMessage id="notfound-page-description" />
          </p>

          <Link
            href={"https://www.downfor.life/"}
            className="inline-flex justify-center px-8 py-3 text-base font-bold text-white rounded-md bg-primary hover:bg-primary/90"
            title={`Link to home page`}
          >
            <FormattedMessage id="notfound-page-button" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default NotFound;
